import AbstractRow from "./AbstractRow.js";

/**
 * Text report row.
 *
 * @param {string} spec.style - Style used to display the title.
 */
class TextRow extends AbstractRow {
	constructor({ style } = {}) {
		super(...arguments);

		this._style = style;
	}

	getStyle() {
		return this._style;
	}

	canBeReferenced() {
		return false;
	}

	canBeUsedInFormulas() {
		return false;
	}

	canBeCalculated() {
		return false;
	}

	accept(visitor) {
		return visitor.visitTextRow(this);
	}

	static getType() {
		return "TextRow";
	}
}

export default TextRow;
